import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/sector-wide-begin-year-estimate/:key?',
    name: 'beginYearEstimateSectorWide',
    component: () =>
      import(/* webpackChunkName:'demo'*/ '@/views/estimateSectorWide/tabMenu/BeginYearSectorWideEstimate.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
  {
    path: '/three-year-estimate-arrgrate/:key?',
    name: 'threeYearEstimateArrgrate',
    component: () =>
      import(/* webpackChunkName:'demo'*/ '@/views/estimateArrgrateThreeYear/ThreeYearEstimateArrgrate.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
  {
    path: '/est-initial-aggregate/:key?',
    name: 'EstInitialAggregate',
    component: () =>
      import(/* webpackChunkName:'demo'*/ '@/views/estInitialAggregate/EstInitialAggregate.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
];